var _rect, _path, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _linearGradient, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    x: 28,
    y: 15,
    fill: "#21a366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#185c37",
    d: "M44,24H12v16c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2V24z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    x: 28,
    y: 24,
    fill: "#107c42"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    x: 12,
    y: 15,
    fill: "#3fa071"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#33c481",
    d: "M42,6H28v9h16V8C44,6.895,43.105,6,42,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21a366",
    d: "M14,6h14v9H12V8C12,6.895,12.895,6,14,6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.319,13H12v24h10.319C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.213,36H12V13.333h10.213c1.724,0,3.121,1.397,3.121,3.121v16.425 C25.333,34.603,23.936,36,22.213,36z",
    opacity: 0.07
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.106,35H12V13.667h10.106c1.414,0,2.56,1.146,2.56,2.56V32.44C24.667,33.854,23.52,35,22.106,35z",
    opacity: 0.09
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "flEJnwg7q~uKUdkX0KCyBa",
    x1: 4.725,
    x2: 23.055,
    y1: 14.725,
    y2: 33.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6731"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flEJnwg7q~uKUdkX0KCyBa)",
    d: "M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16 C24,33.105,23.105,34,22,34z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.807,19h2.386l1.936,3.754L16.175,19h2.229l-3.071,5l3.141,5h-2.351l-2.11-3.93L11.912,29H9.526 l3.193-5.018L9.807,19z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.f4d9ae465c2e7d00856df30804b23e22.svg";
export { ForwardRef as ReactComponent };